// extracted by mini-css-extract-plugin
export default {"animationContainer":"AlertAnimation_animationContainer__EdRQI"};